/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  tenantId:"c9d4c053-49b6-410c-bc78-2d54a9991870",
  branchId:"3d490a70-94ce-4d15-9494-5248280c2ce5",
  passwordExpiredDays:180,
  ResetpasswordNotificationDays:10,
  //*************** If use Prod or Demo URL uncomment this 3 line *********** by Raja
  patientCusID:"27590791",
  patientTenantId:"6bced242-032d-47d6-e7cb-08d8f2bf3f35",
  patientBranchId:"82b28344-d04e-41a0-6465-08d8f2bf3fc3",
  
  dentaliaTenantId:"C70B3D19-3A54-4527-1885-08DB16734232",
  dentalidBranchId:"38319400-77E8-4280-806A-293615CD724E",

 //Demo Patient Portal
  virtualTenant:'6b5d5bf1-e369-4b5d-e9b3-08dacd6f38e4',
  virtualBranch:'4e54f59e-226b-42a3-8ef2-cda3ac8fc727',
  virtualTenantID:'29528982',
 
  // Preprod and Prod Patient Portal
  // virtualTenant:'d29cc395-1670-43eb-f256-08dac9ecc7ac',
  // virtualBranch:'85307fd9-d69a-4b18-8daf-16fb57751469',
  // virtualTenantID:'16640732',

  onBoardTID:'6bced242-032d-47d6-e7cb-08d8f2bf3f35',
  
  production: true,


  brandCode:{key:'shukhee',value:'Shukhee', templateId:'8E89105E-82D7-4C3F-151A-08DD445A6D1B',templateUserId:'5586'},
  // Grameen -> { key:'shukhee', value:'Shukhee', templateId:'8E89105E-82D7-4C3F-151A-08DD445A6D1B',templateUserId:'5586'}

apiUrl:'https://shukhee-nonprod-webapp-win-dfa4cwekf4gpe4gc.southeastasia-01.azurewebsites.net/api',
  baseUrl:'https://shukhee-nonprod-webapp-win-dfa4cwekf4gpe4gc.southeastasia-01.azurewebsites.net/api',
  abhaUrl:'https://ez-hms-dev-abha-app-ser-win.azurewebsites.net/api/',
  abhaM2Url:'https://ez-fhir-dev-transform-hhhvbtg5c0dgbxgv.centralindia-01.azurewebsites.net/',
  deploymentType:'cloud', //onprem & cloud  // If Both onprem,cloud
  //https://localhost:7282/
  
  mailApiUrl:'https://teleduce.corefactors.in/send-email-json-otom/facaefbd-e079-4698-a368-6d81a5a1272e/1016/',

  testUser: {
    // tslint:disable
    token: {
      expires_in: 3600000,
      access_token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjIiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiQFVzZXIiLCJyb2xlIjoidXNlciIsIm5iZiI6MTU2NDA2MTQ1NywiZXhwIjoxNTk1NjgzODU3LCJpc3MiOiJpc3N1ZXJfc2FtcGxlIiwiYXVkIjoiYXVkaWVuY2Vfc2FtcGxlIn0.xAAbQIOsw3ZXlIxDFnv5NynZy7OfzrvrJYWsy2NEBbA',
    },
    // tslint:enable
    email: 'user@user.user',
  },
};
